module.exports = __webpack_public_path__ + "img/Payments.dba0e432.svg";